import { Navigate  } from 'react-router-dom'

import useAuthSession from '../../../hooks/useAuthSession'
import { ROUTES } from '../../../constants/routes'

const AutoLoginRoute = ({ element }) => {
  const user = useAuthSession()

  return(
    user?.accessToken ? <Navigate to={ROUTES.HOME} replace={true}></Navigate> : element
  )
}

export default AutoLoginRoute
